interface CrumbMatch {
  id: string;
  routeId: string;
  hasCrumb: boolean;
}

/**
 * Decide which crumb each claimed header-title anchor replaces.
 *
 * An anchor (a match id or route id) replaces its own match's crumb, or the
 * nearest ancestor's when its route has none — a page rendered by a crumbless
 * index route titles its layout's crumb. An anchor with no crumbed ancestor is
 * appended after the trail. When two anchors resolve to one crumb, the deeper
 * claimant wins.
 */
export function resolveHeaderTitleAnchors(
  matches: readonly CrumbMatch[],
  anchors: readonly string[],
): { replace: ReadonlyMap<string, string>; append: string | undefined } {
  const replace = new Map<string, string>();
  let append: string | undefined;
  const claimed = new Set(anchors);
  let nearestCrumbed: CrumbMatch | undefined;

  for (const match of matches) {
    if (match.hasCrumb) nearestCrumbed = match;
    const anchor = claimed.has(match.id)
      ? match.id
      : claimed.has(match.routeId)
        ? match.routeId
        : undefined;
    if (anchor === undefined) continue;
    if (nearestCrumbed) replace.set(nearestCrumbed.id, anchor);
    else append = anchor;
  }
  return { replace, append };
}
